import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../public/assets/imgs/Kyle_Trammell.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "photo of Kyle Trammell",
  src: _imports_0
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Kyle Trammell")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", { href: "https://www.linkedin.com/in/ceotrammell/" }, "LinkedIn", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/ceotrammell" }, "Github", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, { class: "home-header-sub-ion-card" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_card_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_thumbnail, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _hoisted_2,
          _createVNode(_component_ion_card_title, null, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_card_content, { class: "home-header-sub-ion-card-content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_list, {
            class: "home-header-sub-ion-list",
            lines: "none"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.logoLinkedin }, null, 8, ["icon"]),
                  _hoisted_4,
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.logoGithub }, null, 8, ["icon"]),
                  _hoisted_6,
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}